import {observable, action} from 'mobx';
import localeText from '@locale';
import Security from './models/Security';
import axiosInstance from '~/utils/axiosInstance';
import uris from '~/uris';

class SecurityStore {
  @observable isLoading = false;

  @observable spinLoading = true;

  @observable securityRules = {};

  @observable passwordRules = [];

  @observable minLenght = '8';

  @action.bound
  setLoading(boolean) {
    this.isLoading = boolean;
  }

  @action
  resetSpinLoading() {
    this.spinLoading = false;
  }

  @action
  setSecuritys(data) {
    this.securityRules = data;
  }

  @action.bound
  getSecurityRule(body = {}) {
    this.setLoading(true);
    return axiosInstance
      .get(
        uris.getSecurityRule(),
        {
          ...body
        })
      .then((data) => {
        this.setSecuritys(this.updateSecurityFromServer(data));
        this.resetSpinLoading();
        this.setLoading(false);
      })
      .catch(() => {
        this.setLoading(false);
      });
  }

  @action.bound
  setSecurityRule(data) {
    this.setLoading(true);
    return axiosInstance
      .post(
        uris.setSecurityRule(),
        {
          passwordRequires: data.passwordRequires,
          passwordMinLength: data.passwordMinLength,
          passwordTryTimes: data.passwordTryTimes,
          passwordDuplication: data.passwordDuplication,
          allowMultiSession: data.allowMultiSession,
          sessionTimeOut: data.sessionTimeOut,
          ipWhiteList: data.ipWhiteList,
          ipBlackList: data.ipBlackList,
          mfaType: data.mfaType
        },
        {
          showError: {
            showPopup: true,
            title: localeText('COMMON.TITLE_ADD_FAIL')
          }
        }).then(() => {
        this.getSecurityRule();
      }).catch(() => {
        this.setLoading(false);
        return Promise.reject();
      });
  }

  @action.bound
  updateSecurityFromServer(json) {
    const security = new Security();
    security.updateFromJson(json);
    return security;
  }


  @action.bound
  getPasswordRule(userId) {
    this.setLoading(true);
    return axiosInstance
      .get(uris.getPasswordRule(), {params: {userId}})
      .then((data) => {
        this.setMinLength(data.passwordMinLength);
        this.setPasswordRules(data.passwordRequires || []);
        this.setLoading(false);
      })
      .catch(() => this.setLoading(false));
  }

  @action.bound
  setMinLength(length) {
    this.minLenght = length;
  }

  @action.bound
  setPasswordRules(rules) {
    this.passwordRules = rules;
  }
}

export default new SecurityStore();
